__turbopack_context__.v({
  "markdown": "markdown-styles-module__f3oeWa__markdown",
});
